export const font = {
  fontFamily: `"SF Pro Display"`,
  fontFamilyLink: require("../assets/fonts/SF-Pro-Display-Regular.otf"),
  fontFamilyMedium: `"SF Pro Display Medium"`,
  fontFamilyMediumLink: require("../assets/fonts/SF-Pro-Display-Medium.otf"),
  fontFamilyBold: `"SF Pro Display Bold"`,
  fontFamilyBoldLink: require("../assets/fonts/SF-Pro-Display-Bold.otf"),
  fontSize: "16px"
};